var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCookieLogo = function SvgCookieLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 34 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jb4mdct9da",
    d: "M.144.116H4.24v3.958H.144z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nmaq7gyvuc",
    d: "M.095.025h2.932V3.06H.095z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.535 16.4c-1.745-1.873-3.423-3.827-4.808-5.988-.999-1.558-1.875-3.297-2.928-4.393-.952-.99-1.545-2.055-1.86-3.132-2.127.6-3.578 1.127-5.49 3.102C-8.803 19.668 10.37 40.75 25.105 26.882c1.079-1.015.69-2.237 1.33-3.354-2.032-2.384-4.747-4.815-6.9-7.127",
    fill: "#DE814B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.106 26.882C11.458 37.952-7.54 20.354 4.45 5.988c.188-.226.404-.443.62-.66 2.736-2.736 5.78-4.006 8.766-4.188a.52.52 0 0 1 .552.507c.034 1.762 1.197 2.955 2.878 3.2a.422.422 0 0 1 .346.531 5.948 5.948 0 0 0-.236 1.787c.061 3.177 2.69 5.778 5.867 5.81a5.916 5.916 0 0 0 1.872-.284.416.416 0 0 1 .54.317c.395 2.123 2.322 1.727 3.21 1.421a.468.468 0 0 1 .605.316c1.804 6.471-4.363 12.137-4.363 12.137",
    fill: "#F6B059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.845 13.22c0 1.603-1.3 2.682-2.904 2.682-1.604 0-2.904-1.079-2.904-2.683a2.904 2.904 0 1 1 5.808 0M24.934 20.192c0 1.23-.997 2.227-2.227 2.227s-2.082-.728-2.082-1.958.852-2.496 2.082-2.496 2.227.997 2.227 2.227M8.306 17.475c0 .942-.69 1.485-1.633 1.485-.943 0-1.78-.543-1.78-1.485a1.707 1.707 0 0 1 3.413 0M13.526 23.264a.768.768 0 1 1-1.536 0 .768.768 0 0 1 1.536 0M9.126 7.487a.853.853 0 1 1-1.707 0 .853.853 0 0 1 1.707 0",
    fill: "#6D420D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.656 .1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ocpawiujbb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jb4mdct9da"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.234 2.187c.09 1.042-.815 1.887-2.02 1.887S.084 3.15.147 2.01C.21.87 1.115.026 2.167.124c1.052.098 1.978 1.021 2.067 2.063",
    fill: "#F6B059",
    mask: "url(#ocpawiujbb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.323 3.756a2.2 2.2 0 0 0 1.25-.357c-.36.467-.982.775-1.704.775-1.203 0-2.13-.925-2.066-2.063a2.056 2.056 0 0 1 .88-1.597 2.054 2.054 0 0 0-.425 1.18c-.049 1.128.877 2.053 2.065 2.062",
    fill: "#DE814B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.77 8.17c-.051.689-.634 1.284-1.3 1.33-.667.044-1.2-.515-1.19-1.249.011-.734.593-1.33 1.301-1.33s1.24.56 1.189 1.249",
    fill: "#F6B059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.74 9.209c.27-.017.525-.122.737-.287-.242.324-.609.55-1.008.577-.666.045-1.198-.514-1.188-1.248.006-.44.215-.832.534-1.074-.16.219-.257.49-.263.784-.015.73.517 1.289 1.188 1.248",
    fill: "#DE814B"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.592 7.228)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k78e4dkykd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nmaq7gyvuc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.023 1.494c-.06.81-.745 1.51-1.53 1.563C.71 3.11.083 2.453.095 1.59.108.725.792.025 1.625.025c.832 0 1.458.658 1.398 1.469",
    fill: "#F6B059",
    mask: "url(#k78e4dkykd)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.404 9.943c.317-.019.617-.143.866-.336-.284.38-.716.647-1.185.678-.783.053-1.41-.605-1.397-1.467.007-.517.253-.979.628-1.264a1.618 1.618 0 0 0-.31.922c-.018.858.609 1.516 1.398 1.467",
    fill: "#DE814B"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCookieLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cookie_logo.10e5230a.svg";
export { ForwardRef as ReactComponent };